import styled from 'styled-components'

export const CouponUi = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
`
